// extracted by mini-css-extract-plugin
export default {"wrapper":"Zo-z","response":"_o-z","error":"ap-z","disabled":"bp-z","buttons":"cp-z","feedbackQuestionSection":"dp-z","yesNoWrapper":"ep-z"};